import {Component, Input, input} from '@angular/core';
import {AlertMessage} from "../../../core/interfaces/alert.interface";
import {NgIf} from "@angular/common";
import {MatIconModule} from '@angular/material/icon';

@Component({
  selector: 'app-alerts',
  standalone: true,
  imports: [NgIf,MatIconModule],
  templateUrl: './alerts.component.html',
  styleUrl: './alerts.component.css'
})
export class AlertsComponent {
  @Input() alertData: AlertMessage | null = null;
}
